import { useLocation } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

/** Global floating theme toggle — omitted on admin/dashboard pages. */
export default function FixedThemeToggle() {
  const { pathname } = useLocation();
  if (
    pathname === "/" ||
    pathname.startsWith("/listings") ||
    pathname.startsWith("/sell") ||
    pathname.startsWith("/dealers") ||
    pathname.startsWith("/dealer/") ||
    pathname.startsWith("/car/") ||
    pathname.startsWith("/login") ||
    pathname.startsWith("/account") ||
    pathname.startsWith("/admin") ||
    pathname.startsWith("/dashboard")
  ) {
    return null;
  }
  return <ThemeToggle fixed />;
}
